import { createContext, useContext, ReactNode } from 'react';

interface CoachContextType {
  coachId: string | null;
}

const CoachContext = createContext<CoachContextType>({ coachId: null });

export const useCoachContext = () => useContext(CoachContext);

interface CoachProviderProps {
  coachId: string | null;
  children: ReactNode;
}

export const CoachProvider = ({ coachId, children }: CoachProviderProps) => {
  return (
    <CoachContext.Provider value={{ coachId }}>
      {children}
    </CoachContext.Provider>
  );
};
